import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-featurescomparatore',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class FeaturesComparatoreComponent implements OnInit {

  constructor() { }

  @Input() testoiniziale: string;

  ngOnInit() {
    if (this.testoiniziale == null || this.testoiniziale == "") { this.testoiniziale = "Calcola il tuo preventivo"; }
  }

}



// WEBPACK FOOTER //
// ./src/app/featuresComparatore/features.component.ts